module.exports = __webpack_public_path__ + "static/media/purpleCross2.4af7b1f9.svg";